/**
 * Created by karthik.ar on 24-05-2017.
 */
import { PipeTransform, Pipe } from '@angular/core';
import { BetlimitService } from '../services/betlimit.service';
import { UtilService } from '../util/UtilService';
import { CurrencyConstant } from '../constant/currency.constant';

@Pipe({
    name: 'currencysymbol',
    standalone: false
})
export class CurrencySymbolPipe implements PipeTransform {
  constructor(
    private _betLimitService: BetlimitService,
    private _utilService: UtilService
  ) {
    //console.log("getCurrentLang",this.getCurrentLang)
  }
  transform(val: any, changeCurrencyCode = undefined): string {
    const currencyCode =
      changeCurrencyCode || this._betLimitService.currencyCode.toUpperCase();

    const definition = CurrencyConstant.CURRENCIES[currencyCode];

    if (!definition) {
      // If the currency code is not found in the definition, it means it's a symbol
      return `${currencyCode} ${val}`;
    }

    const symbol = definition.symbol || '?';

    if (symbol === '?') {
      console.warn(`Currency symbol not found for code: ${currencyCode}`);
    }

    const position = definition.position || 'front';

    return this._formatWithSpacing(
      val,
      symbol,
      position,
      definition.hasSpacing
    );
  }

  private _formatWithSpacing(
    value: any,
    symbol: string,
    position: 'front' | 'back',
    hasSpacing: boolean
  ): string {
    const needsSpace = hasSpacing && !/^\s/.test(symbol) && !/\s$/.test(symbol);
    const separator = needsSpace ? ' ' : '';

    if (position === 'back') {
      return `${value}${separator}${symbol}`;
    } else {
      return `${symbol}${separator}${value}`;
    }
  }
}
